exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-password-password-errors-and-info-block-password-errors-and-info-block-styles__absolute {\n  position: absolute;\n}\n", ""]);

// Exports
exports.locals = {
	"absolute": "src-password-password-errors-and-info-block-password-errors-and-info-block-styles__absolute"
};